var React = require('react');

function FbInlineInline (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#fff;}.cls-2{fill:#909292;}")),React.createElement("rect",{"className":"cls-2","x":"2.5","y":"2.5","width":"300","height":"300","rx":"15.45","ry":"15.45","key":1}),React.createElement("path",{"className":"cls-1","d":"M187.12,302.49v-108.94h36.32l6.91-45.06h-43.24v-29.24c0-12.33,6.04-24.35,25.4-24.35h19.66v-38.36s-17.84-3.05-34.9-3.05c-35.61,0-58.88,21.58-58.88,60.65v34.35h-39.58v45.06h39.58v108.94h48.72Z","key":2})]);
}

FbInlineInline.defaultProps = {"width":"26","height":"23","id":"Layer_1","viewBox":"0 0 305 305"};

module.exports = FbInlineInline;

FbInlineInline.default = FbInlineInline;
